import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Stack,
  Tooltip,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import StreakCounter from "../../../../components/StreakCounter";

const StarIndicator = ({ guessesLeft }) => {
  const totalGuesses = 5;
  return (
    <Stack direction="row" spacing={{ xs: 0.5, sm: 1 }} alignItems="center">
      {Array.from({ length: totalGuesses }).map((_, i) => (
        <StarIcon
          key={i}
          sx={{
            fontSize: { xs: 24, sm: 32 },
            color: i < guessesLeft ? "#5780BD" : "#3F3F3F",
            transition: "color 0.2s, transform 0.2s",
          }}
        />
      ))}
    </Stack>
  );
};

const GameHUD = ({
  currentDate,
  guessesLeft,
  streak,
  isStreakActive,
  onHelp,
}) => (
  <Paper
    elevation={2}
    sx={{
      width: "100%",
      maxWidth: 420,
      p: { xs: 1, sm: 2 },
      borderRadius: 3,
      boxShadow: 2,
      mb: { xs: 0.25, sm: 0.5 },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: { xs: 0.75, sm: 1.5 },
      bgcolor: "white",
    }}
  >
    {/* Top row: Help | Date | Streak */}
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: { xs: 0.5, sm: 1 },
      }}
    >
      <Tooltip title="How to Play">
        <IconButton
          onClick={onHelp}
          sx={{
            color: "#222",
            padding: { xs: 0.5, sm: 1 },
          }}
        >
          <HelpOutlineIcon sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }} />
        </IconButton>
      </Tooltip>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: { xs: "1rem", sm: "1.2rem" },
          letterSpacing: 0.5,
          color: "#222",
          flex: 1,
          textAlign: "center",
        }}
      >
        {currentDate.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        })}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <StreakCounter streak={streak} isActive={isStreakActive} />
      </Box>
    </Box>
    {/* Pill-shaped star bar */}
    <Box
      sx={{
        display: "flex",
        gap: { xs: 0.5, sm: 1 },
        background: "#F5F7FA",
        borderRadius: "999px",
        px: { xs: 1.5, sm: 2 },
        py: { xs: 0.25, sm: 0.5 },
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        maxWidth: 320,
        mx: "auto",
      }}
    >
      <StarIndicator guessesLeft={guessesLeft} />
    </Box>
  </Paper>
);

export default GameHUD;
